<!-- 学校-机构课程统计 -->
<template>
  <div class="container">
    <div class="index" v-show="!detail.show">
      <div class="title">
        <span>{{$route.name}}</span>
      </div>

      <header>
        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>机构提供课程数TOP5</span>
          </div>
          <div id="echarts-box1"></div>
        </div>

        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>机构开班数TOP5</span>
          </div>
          <div id="echarts-box2"></div>
        </div>
      </header>

      <div class="query">
        <el-form ref="form" :model="form" label-width="90px"> </el-form>
        <div class="query">
          <el-form ref="form" :inline="true" :model="form" label-width="90px">
            <el-form-item label="">
              <el-select
                v-model="form.schoolYearSemester"
                placeholder="请选择学年学期"
                clearable
              >
                <el-option
                  v-for="item in semesterList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-select
                v-model="form.orgId"
                placeholder="请选择机构"
                clearable
               >
                <el-option
                  v-for="item in unitList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary" size="small" @click="searchFun">搜索</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column align="center" prop="extOrgName" label="机构名称">
          </el-table-column>
          <el-table-column align="center" prop="courseNum" label="提供课程数">
          </el-table-column>
          <el-table-column align="center" prop="kbNum" label="学校开班次数">
          </el-table-column>
          <el-table-column align="center" prop="gradeName" label="课程覆盖年级">
          </el-table-column>
          <el-table-column align="center" prop="classNum" label="课程总数">
          </el-table-column>
          <el-table-column align="center" prop="teacherNum" label="参与教师数">
          </el-table-column>
          <el-table-column align="center" label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="toDetail(scope)"
                >查看详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页组件-->
      <el-pagination
        background
        :current-page="page.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.totalPage"
        layout="total,prev, pager, next,jumper,sizes"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></el-pagination>
    </div>
    <Detail :info="detail.info" v-if="detail.show" @to-index="toIndex"></Detail>
  </div>
</template>

<script>
import api from "@/api/wisdomSchool/index";
// import stockOutApi from '@/api/order/stockOut';
// import store from '@/store';
import * as echarts from "echarts";
export default {
  components: {
    Detail: () => import("./details.vue"),
  },
  data() {
    return {
      form: {
        schoolYearSemester: "",
        orgId: "",
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 0,
      },
      tableData: [
        {extOrgName:'欧美思',courseNum:'8',kbNum:'10',gradeName:'三年级四年级五年级六年级',classNum:'400',teacherNum:'8'},
        {extOrgName:'智课',courseNum:'6',kbNum:'9',gradeName:'一年级二年级',classNum:'300',teacherNum:'8'},
        {extOrgName:'第七感官',courseNum:'8',kbNum:'1',gradeName:'一年级二年级',classNum:'200',teacherNum:'5'},
        {extOrgName:'黑色空间',courseNum:'5',kbNum:'5',gradeName:'三年级四年级',classNum:'300',teacherNum:'8'},
        {extOrgName:'小鱼',courseNum:'8',kbNum:'10',gradeName:'三年级四年级五年级六年级',classNum:'400',teacherNum:'1'},
        {extOrgName:'果力教育',courseNum:'3',kbNum:'8',gradeName:'一年级二年级',classNum:'200',teacherNum:'8'},
        {extOrgName:'智位科技',courseNum:'2',kbNum:'3',gradeName:'三年级四年级',classNum:'100',teacherNum:'8'},
      ],
      unitList: [
        {id:'jg1',label:'果力教育'},
        {id:'jg2',label:'欧美思'},
        {id:'jg3',label:'智课'},
        {id:'jg4',label:'第七感官'},
        {id:'jg5',label:'黑色空间'},
        {id:'jg6',label:'小鱼'},
      ],//机构数据列表
      semesterList: [
        {id:'xq1',label:'2021~2022年度下学期'},
				{id:'xq2',label:'2021~2022年度上学期'},
				{id:'xq3',label:'2020~2021年度下学期'},
				{id:'xq4',label:'2020~2021年度上学期'},
				{id:'xq5',label:'2019~2020年度下学期'},
				{id:'xq6',label:'2019~2020年度上学期'},
      ],
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList"))||[],
      userInfo:JSON.parse(sessionStorage.getItem('userInfo')),
      detail: {
        info: {},
        show: false,
      },
    };
  },
  mounted() {
    this.unitList=this.userInfo?.user_top_org?.map(v=>({id:v.org_id,label:v.org_name}))
    this.init();
  },
  created(){
     if(this.semesterArr && this.semesterArr.length>0){
          this.semesterList = this.semesterArr.map((v) => ({
          label: v.schoolYear + "年度" +(v.semester ===1?'上学期':'下学期'),
          value:v.schoolYear+'_'+v.semester,
          id: v.id,
        }));
    }
    this.getDataList();
  },
  methods: {
    async getDataList() {
      let params = {
        schoolYearSemester: this.form.schoolYearSemester,
        orgId:sessionStorage.getItem('orgId'),
        gradeId:'',
        extOrgName: "",
        platformCode: sessionStorage.getItem('platformCode'),
        page: this.page.pageNum,
        limit: this.page.pageSize,
      };
      // var { data, code } = await api.handleExternalList(params);
      // if (code == "0") {
      //   this.tableData = data.list;
      //   this.page.totalPage = data.total;
      // }
    },
    searchFun(){
      this.page.pageNum=1;
			this.getDataList();
    },
    sizeChangeHandle(val) {
      this.page.pageNum=1
      this.page.pageSize = val;
      this.getDataList()
    },

    currentChangeHandle(val) {
      this.page.pageNum=1
      this.page.pageNum = val;
      this.getDataList()
    },
    toDetail(scope) {
      console.log(scope);
      this.detail.info = scope.row;
      this.detail.show = true;
    },
    toIndex() {
      this.detail.show = false;
    },
    init(){
      let vm = this;
      this.$nextTick(() => {
        // 柱状图
        let chartDom1 = document.getElementById('echarts-box1');
        let myChart1 = echarts.init(chartDom1);
        let option1 = {
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: ['欧美\n思', '智课', '欧美\n思', '第七\n感官', '黑色\n空间'],
            // splitLine: {show: false},//去除网格分割线
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: [8, 6, 5, 4, 3],
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    // { offset: 0, color: '#009DFD' },
                    { offset: 1, color: '#5BB0FF' },
                  ]),
                  // barBorderRadius: 16, // 柱子圆角, 单位为px
                  label: {
                    formatter: "{c}",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999"
                    }
                  },
                },
                
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart1.setOption(option1);

        // 柱状图
        let chartDom2 = document.getElementById('echarts-box2');
        let myChart2 = echarts.init(chartDom2);
        let option2 = {
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: ['欧美\n思', '智课', '欧美\n思', '第七\n感官', '黑色\n空间'],
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: [10, 8, 6, 5, 4	],
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: '#51D6A6' },
                  ]),
                  label: {
                    formatter: "{c}",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999"
                    }
                  },
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart2.setOption(option2);
      });
    },
  },
};
</script>
<style scoped>
.el-range-editor {
  width: 120%;
}
.el-range-editor >>> .el-range-separator {
  width: 8%;
}
::v-deep .el-form .el-input__inner {
  width: 189px;
  height: 32px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}

::v-deep .el-table__header tr th {
  background: #f7f7f7;
  box-shadow: 0px 1px 0px #eaeaea;
}

::v-deep .el-date-editor .el-range-separator {
  line-height: 22px;
}
</style>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 0 0 2% 2%;
}
.query {
  position: relative;
  margin-bottom: 2%;
}
.searchBtn {
  position: absolute;
  top: 50%;
  right: 5%;
}
.el-pagination {
  margin: 20px 0;
  padding-bottom: 30px;
  text-align: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 10px;
  span {
    font-family: "PingFang SC Bold";
    font-weight: bold;
    font-size: 20px;
    text-align: left;
    color: #000;
  }
}

header{
    width: 100%;
    height: 350px;
    display: flex;
    .header-item{
      width: 50%;
      .header-item-title{
        font-size: 18px;
        color: #333;
        display: flex;
        align-items: center;
        .circle{
          width: 8px;
          height: 8px;
          display: inline-block;
          background: #4991e1;
          border-radius: 50%;
          margin-right: 10px;
        }
      }
      .header-item-text{
        font-size: 14px;
        color: #666;
        padding-left: 20px;
        margin-top: 5px;
      }
    }
    #echarts-box1, #echarts-box2{
      width:90%;
      height:280px;
    }
}
</style>
